exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-fileupload .ui-corner-top {\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n}\n.ui-fileupload .ui-corner-bottom {\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.ui-fileupload .ui-button {\n  border-radius: 2px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /rightcompound/angular/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/rightcompound/angular/node_modules/postcss-loader?{"ident":"postcss"}!/rightcompound/angular/src/assets/primeng/file-upload/css/primeng.file-upload.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/primeng/file-upload/css/primeng.file-upload.css
// module chunks = styles